import { __assign, __makeTemplateObject, __rest } from "tslib";
import { TextInput as GrommetTextInput, } from 'grommet';
import * as React from 'react';
import styled from 'styled-components';
import asRendition from '../../asRendition';
import { emphasized, monospace } from '../../utils';
var getBorderColor = function (props) {
    if (props.invalid) {
        return props.theme.colors.danger.main;
    }
    if (props.valid) {
        return props.theme.colors.success.main;
    }
};
var StyledGrommetInput = styled(GrommetTextInput)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", ";\n\t", ";\n\tpadding: ", ";\n\tpadding-left: 20px;\n\n\tcolor: ", ";\n\tcursor: ", ";\n\tborder-color: ", ";\n\n\t&:focus {\n\t\tborder-color: ", ";\n\t}\n"], ["\n\t", ";\n\t", ";\n\tpadding: ", ";\n\tpadding-left: 20px;\n\n\tcolor: ", ";\n\tcursor: ", ";\n\tborder-color: ", ";\n\n\t&:focus {\n\t\tborder-color: ", ";\n\t}\n"])), monospace, emphasized, function (props) { return (props.emphasized ? '14px' : '10px'); }, function (props) { return props.theme.colors.text.main; }, function (props) { return (props.disabled ? 'not-allowed' : 'auto'); }, getBorderColor, function (props) { return props.theme.colors.tertiary.main; });
var BaseInput = React.forwardRef(function (_a, ref) {
    var otherProps = __rest(_a, []);
    return React.createElement(StyledGrommetInput, __assign({}, otherProps, { ref: ref }));
});
export var Input = asRendition(BaseInput);
var templateObject_1;
